export const activeOptions = [
  { label: "All", value: "all" },
  { label: "Yes", value: 1},
  { label: "No", value: 0 },
];

export const recurringValues = {
  0: "",
  1: "Weekly",
  2: "Monthly",
}

export const recurringOptions = [
  { label: "No", value: 0 },
  { label: "Weekly", value: 1 },
  { label: "Monthly", value: 2 },
];